import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/styles';
import {Paper, Tab, Tabs} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
    },
    tabPanel: {
        padding: theme.spacing(2),
        backgroundColor: '#f4f6f8',
    },
}));

const NavTabs = props => {
    const {className, ...rest} = props;
    const classes = useStyles(props);
    const handleChange = (event, newValue) => {
        props.history.push(newValue);
    };

    return (
        <Paper
            {...rest}
            className={clsx(classes.root, className)}
        >
            <Tabs
                indicatorColor="primary"
                onChange={handleChange}
                textColor="primary"
                value={props.location.pathname}
                variant="fullWidth"
            >
                <Tab
                    label="Daily"
                    value="/ecdi/daily"
                />
                <Tab
                    label="Weekly"
                    value="/ecdi/weekly"
                />
                <Tab
                    label="Monthly"
                    value="/ecdi/monthly"
                />
            </Tabs>
        </Paper>
    );
};

NavTabs.propTypes = {
    className: PropTypes.string,
    history: PropTypes.object,
    location: PropTypes.object,
};

export default NavTabs;
